/**
 * Created by Jan on 12.10.2016.
 */

(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.ActionHandlers;

    (function (ActionHandlers, $, undefined) {
        /**
         * @memberOf Lfl.ActionHandlers
         */
        Lfl.ActionHandlers.OnDragHandlers;

        (function (OnDragHandlers, $, undefined) {
            if (Lfl.Files.isLoadedAlready(Lfl.ActionHandlers.OnDragHandlers, 'OnDragStopCallbacksProcessor')) {
                return;
            }


            /*
             |===========================================================================================================
             | Class definition
             |===========================================================================================================
             */

            /**
             * Waits for results from specified on drag handlers, processes them and then calls the appropriate callbacks.
             * @memberOf Lfl.ActionHandlers.OnDragHandlers
             * @lends Lfl.ActionHandlers.OnDragHandlers.OnDragStopCallbacksProcessor
             * @param {Lfl.ActionHandlers.OnDragHandlers.ModalOdh[]} handlers
             * @param {jQuery} $element
             * @param event
             * @param {{}} callbacks
             * @param {function} callbacks.success The method which will be called if all handlers allow the action.
             * @param {function} callbacks.failure The method which will be called if at least one handler forbids
             * @param {Lfl.Tiem.Core.TiemOdhDataCrate} dataCrate
             *
             * @constructor
             */
            Lfl.ActionHandlers.OnDragHandlers.OnDragStopCallbacksProcessor = function (handlers, $element, event, callbacks, dataCrate) {
                /*
                 |-------------------------------------------------------------------------------------------------------------------
                 | Construction
                 |-------------------------------------------------------------------------------------------------------------------
                 */

                /**
                 * An id indexed list of results in the form of int : result.
                 * @type {{}}
                 */
                var results = {};

                /*
                 |-----------------------------------------------------------------------------------------------------------
                 | Public methods
                 |-----------------------------------------------------------------------------------------------------------
                 */

                this.process = function () {
                    _.each(handlers,
                        function (/** Lfl.ActionHandlers.OnDragHandlers.ModalOdh */handler, key) {
                            handler.onStop($element, event, key, registerHandlerResult, dataCrate);
                            results[key] = undefined;
                        });
                };

                /*
                 |-----------------------------------------------------------------------------------------------------------
                 | Private methods
                 |-----------------------------------------------------------------------------------------------------------
                 */

                /**
                 * Processes the result of a handler.
                 *
                 * @param {int} id The id of the handler
                 * @param {bool} result
                 * @returns {*}
                 */
                function registerHandlerResult(id, result) {
                    results[id] = result;

                    checkHandlersStatus();
                }

                function checkHandlersStatus() {
                    var allHandlersFinished = true;
                    var allHandlersSuccessful = true;
                    _.each(results, function (value, key) {
                        if (typeof value === 'undefined') {
                            allHandlersFinished = false;
                        } else if (value !== true) {
                            allHandlersSuccessful = false;
                        }
                    });

                    if (allHandlersFinished === true) {
                        if (allHandlersSuccessful) {
                            callbacks.success();
                        } else {
                            callbacks.failure();
                        }
                    }
                }

            };
        }(ActionHandlers.OnDragHandlers = ActionHandlers.OnDragHandlers || {}, jQuery));
    }(Lfl.ActionHandlers = Lfl.ActionHandlers || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));

